import financeiroApi from './financeiroApi';

const PATH = '/api/v1/backend/imposto';

export default {
  buscarImpostos: async (params) => {
    return financeiroApi.get(`${PATH}`, { params });
  },

  buscarImposto: async (id) => {
    return financeiroApi.get(`${PATH}/${id}`);
  },

  criarImposto: async (Imposto) => {
    return financeiroApi.post(`${PATH}`, Imposto);
  },

  atualizarImposto: async (id, Imposto) => {
    return financeiroApi.put(`${PATH}/${id}`, Imposto);
  },

  removerImpostos: async (filtro) => {
    return financeiroApi.delete(`${PATH}`, { data: filtro });
  },

  pesquisar: async (params) => {
    return financeiroApi.get(`${PATH}/pesquisar`, { params });
  },
};
